<div class="customers">
    <div>
        <div class="card-body">
            <div class="row">
                <div class="separator" [ngClass]="'color-back-area-' + areaNumber" style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                    <div class="estrategia-text"><strong>{{subdimensionData?.subdimension}}</strong></div>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let estrategiaData of subdimensionData.estrategias; let indice=index;">
                    <app-estrategia-anual [estrategiaData]="estrategiaData" [areaNumber]="areaNumber" [readonly]="readonly"></app-estrategia-anual>
                </div>
            </div>
        </div>
    </div>
</div>